export default __webpack_public_path__ + "static/media/dangerIcon.f38bb416.svg";